import React, { useState } from 'react';
import { BarChart3 } from 'lucide-react';
import GoAgentManagement from './GoAgentManagement';
import EnhancedDeviceManagement from './EnhancedDeviceManagement';
import { HubSection } from './ui/HubShell';

type InventoryTab = 'go-agent' | 'hardware-software';

const TABS: { id: InventoryTab; label: string }[] = [
  { id: 'go-agent', label: 'Go Agent Status' },
  { id: 'hardware-software', label: 'Hardware & Software' },
];

const InventoryHub: React.FC = () => {
  const [activeTab, setActiveTab] = useState<InventoryTab>('go-agent');

  return (
    <HubSection
      title="Inventory"
      subtitle="Hardware, software, and Go Agent status across the fleet."
      icon={<BarChart3 size={20} />}
      eyebrow="Fleet"
      tabs={TABS}
      tab={activeTab}
      onTabChange={setActiveTab}
    >
      {activeTab === 'go-agent' && <GoAgentManagement />}
      {activeTab === 'hardware-software' && <EnhancedDeviceManagement />}
    </HubSection>
  );
};

export default InventoryHub;
